<template>
  <div class="user-list-container">
    <div
      class="user-list-header"
      style="padding: 20px; display: flex; justify-content: flex-end"
    >
      <el-popover
        placement="left"
        width="400"
        trigger="click"
        v-model="visible"
      >
        <div class="tag-selector">
          <!-- 选项列表 -->
          <div class="options">
            <el-checkbox-group v-model="selectedTags">
              <el-checkbox label="高活跃" />
              <el-checkbox label="普通" />
              <el-checkbox label="黑名单" />
            </el-checkbox-group>
          </div>

          <!-- 新建标签 -->
          <div class="new-tag">
            <el-button type="text" @click="handleNewTag">新建标签</el-button>
          </div>

          <!-- 操作按钮 -->
          <div class="actions">
            <CustomFormButton
              v-for="button in actionButtons.topArticleButtons"
              :isShowList="['取消', '确认']"
              :key="button.id"
              :text="button.text"
              :type="button.type"
              :size="button.size"
              :isPlain="button.isPlain"
              :icon="button.icon"
              :customStyle="button.customStyle"
              @click="handleClick(button, '打标签')"
            />
            <!-- <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleConfirm">确认</el-button> -->
          </div>
        </div>
        <el-button
          plain
          slot="reference"
          type="warning"
          size="small"
          icon="el-icon-wind-power"
          >打标签</el-button
        >
      </el-popover>
      <el-button
        style="margin-left: 20px"
        type="danger"
        size="small"
        icon="el-icon-delete"
        plain
        @click="handleClick(null, '黑名单')"
        >黑名单</el-button
      >
    </div>
    <CustomTable
      :tableData="tableData"
      :tableHeaders="tableHeaders"
      :showSelection="true"
      :pagination="pagination"
      :loading="tableLoading"
      tableHeight="calc(100vh - 200px)"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template #action="{ row }">
        <div
          v-for="button in actionButtons.tableArticleButtons"
          :key="button.id"
        >
          <el-button
            v-if="button.id === 'deleteRow' || button.id === 'editRow'"
            class="custom-btn none"
            size="small"
            @click="handleClick(button, row)"
            >{{ button.text }}</el-button
          >
        </div>
      </template>
      <template #status="{ row, column, index }">
        <div
          v-if="column.property === 'avatar'"
          style="cursor: pointer"
          @click="handlePreview(row)"
        >
          <Avatar size="medium" :src="row.avatar" />
        </div>
        <div v-if="column.property === 'isSubscribed'">
          <span>{{ row[column.property] === 1 ? "是" : "否" }}</span>
        </div>
        <div v-if="column.property === 'followSource'">
          <span>{{
            row[column.property] === 1
              ? "二维码扫码"
              : row[column.property] === 2
              ? "微信搜索"
              : "分享"
          }}</span>
        </div>
        <div v-if="column.property === 'tags'">
          <!-- 根据状态值显示不一样的小按钮颜色 -->
          <el-tag
            v-if="row[column.property] == 1"
            style="background-color: #eaf3fe; color: #348cf8"
          >
            普通
          </el-tag>
          <el-tag
            v-if="row[column.property] == 2"
            style="background-color: #eaf3fe; color: #348cf8"
          >
            草稿
          </el-tag>
          <el-tag
            v-if="row[column.property] == 3"
            style="background-color: #feeeee; color: #ff3d00"
          >
            黑名单
          </el-tag>
          <el-tag
            v-if="row[column.property] == 4"
            style="background-color: #fcf5ed; color: #edab5a"
          >
            高活跃
          </el-tag>
        </div>
      </template>
    </CustomTable>
  </div>
</template>
<script>
// 引入图片预览组件API
import { api as viewerApi } from "v-viewer";
import { userTableHeaders, actionButtons } from "@/utils/defaultData";
import { tableHeaders } from "../../../../../utils/defaultData";
export default {
  name: "WechatUserInfoIndex",
  props: {
    datas: Object,
  },
  data() {
    return {
      visible: false,
      selectedTags: ["高活跃"], // 默认选中“高活跃”
      actionButtons: actionButtons,
      tableHeaders: tableHeaders.userManagerHeaders,
      pagination: {
        total: 14,
        currentPage: 1,
        pageSize: 10,
      },
      tableLoading: false,
      tableData: [],
    };
  },
  mounted() {
    actionButtons.topArticleButtons[4].customStyle.paddingLeft = "20px";
    actionButtons.topArticleButtons[4].customStyle.paddingRight = "20px";
    actionButtons.topArticleButtons[5].customStyle.paddingLeft = "20px";
    actionButtons.topArticleButtons[5].customStyle.paddingRight = "20px";
    // actionButtons.tableArticleButtons[1].text = "修改备注";
    console.log("获取按钮", actionButtons);

    // 获取用户列表数据
    this.getUserList();
  },
  methods: {
    // ✅ 图片预览事件 【核心需求】
    handlePreview(row) {
      console.log("图片预览了", row);
      //   // 预览图片
      viewerApi({ images: [row.avatar], initialViewIndex: 0 });
      //   console.log("预览了", file, this.fileList, previewImages);
    },
    // 获取用户列表
    getUserList() {
      this.tableLoading = true;
      this.$api.admin.user.getUserListAPI().then((res) => {
        console.log("获取用户列表", res);
        if (res.code == 200) {
          this.tableLoading = false;
          this.tableData = res.data;
          // this.userPagination.total = res.data.total;
        }
      });
    },
    handleNewTag() {
      this.$message.info("新建标签功能待实现");
      // 可扩展为弹窗输入新标签名并添加到选项
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$emit("confirm", this.selectedTags);
    },
    // 编辑弹窗取消回调
    // 处理每页显示条数变化
    handleSizeChange(newPagination) {
      console.log("每页条数变化", newPagination);
      this.pagination = newPagination;

      // this.getList();
    },
    // 处理页码变化
    handleCurrentChange(newPagination) {
      this.tableLoading = true;
      console.log("页码变化", newPagination);
      this.tableData = [
        {
          name: "最后加的",
          type: "男",
          image:
            "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
          uploadTime: "2025-09-11 10:00:00",
          uploadUser: "admin",
          status: false,
        },
      ];
      // this.pagination = newPagination;
      // this.getList();
    },
    // 处理选择事件
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log("父组件中选项变更了", this.selectedRows);
    },
    handleClick(button, type) {
      console.log("点击了", button, type);
      if (type === "打标签") {
        // 点击取消按钮
        if (button.id === "cancel") return (this.visible = false);
        // 点击确定按钮
        this.$message.info("打标签功能待实现");
      } else if (type === "黑名单") {
        this.$message.info("黑名单功能待实现");
      } else if (button.id === "editRow") {
        this.$message.info("编辑用户信息功能待实现");
      } else {
        this.$message.info("其他操作功能待实现");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.tag-selector {
  padding: 16px;
}

.options {
  margin-bottom: 16px;
}

.new-tag {
  margin-bottom: 24px;
}

.new-tag .el-button {
  padding: 0;
  color: #409eff;
  font-size: 14px;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}
</style>
